import {Injectable} from "@angular/core";
import {ApiService} from "../api.service";
import {HttpClient, HttpResponse} from "@angular/common/http";
import {TransportServiceFilter} from "../../filters/transport-service.filter";
import {TransportService} from "../../../shared/types/models/transport-service.model";
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class TransportServiceService extends ApiService<TransportService> {
  public filter = new TransportServiceFilter();

  constructor(protected httpClient: HttpClient) {
    super(httpClient, 'transportservice');
  }

  public getFilter(): TransportServiceFilter {
    return this.filter;
  }

  public getWithAccount$(id: string, filter?: any): Observable<HttpResponse<TransportService[]>> {
    const url = `${this.url}/account/${id}`;
    return this.httpClient.get<TransportService[]>(url, { params: filter, observe: 'response'});
  }

  public getRouteListings$(id: string): Observable<HttpResponse<any[]>> {
    const url = `${this.url}/listings/${id}`;
    return this.httpClient.get<any[]>(url, { observe: 'response'});
  }
}
